import { render, staticRenderFns } from "./dayCourse.vue?vue&type=template&id=222953ae&scoped=true"
import script from "./dayCourse.vue?vue&type=script&lang=ts"
export * from "./dayCourse.vue?vue&type=script&lang=ts"
import style0 from "./dayCourse.vue?vue&type=style&index=0&id=222953ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222953ae",
  null
  
)

export default component.exports